import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import { getIn } from 'formik'

import FieldLabelWrapper from '../../../../../../../../../../features/components/Form/FieldLabelWrapper'
import Field from '../../../../../../../../../../components/Form/Field'
import ErrorMessage from '../../../../../../../../../../components/Form/ErrorMessage'

import { fieldValueValidator } from './helpers'

import { IMD_PERCENTAGE, imdFields, STAKEHOLDERS_LIST } from '../../../../../../stakeholdersFields'

import useStyles from '../styles'

const imdRows = [
  [1, 2, 3, 4, 5],
  [6, 7, 8, 9, 10]
]

const ImdPercentageFields = ({ formik, index }) => {
  const { t } = useTranslation()

  const classes = useStyles()

  const { errors, touched } = formik
  const path = `${STAKEHOLDERS_LIST}[${index}][${IMD_PERCENTAGE}]`
  const imdPercentageError = getIn(errors, path)
  const imdPercentageTouched = getIn(touched, path)

  return (
    <FieldLabelWrapper label={t('Index of Multiple Deprivation')}>
      {imdRows.map((row, rowIndex) => (
        <div key={rowIndex} className={classnames(classes.row, classes.imdRow)}>
          {row.map(fieldNumber => {
            const fieldKey = `imd_${fieldNumber}`
            return (
              <FieldLabelWrapper
                key={fieldNumber}
                label={t(String(fieldNumber))}
                className={classnames(classes.subLevelFieldWrapper)}
                labelClassName={classes.subLevelLabel}
              >
                <Field
                  className={classes.fieldInRow}
                  formik={formik}
                  name={`${path}[${imdFields[fieldKey]}]`}
                  symbol={'%'}
                  symbolPosition="end"
                  type={'number'}
                  isAllowed={fieldValueValidator}
                />
              </FieldLabelWrapper>
            )
          })}
        </div>
      ))}

      {imdPercentageError && imdPercentageTouched && <ErrorMessage error={imdPercentageError} />}
    </FieldLabelWrapper>
  )
}

ImdPercentageFields.propTypes = {
  formik: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default ImdPercentageFields
